import {Injectable} from '@angular/core';
import {Subject} from "rxjs/Subject";
import {Http} from "@angular/http";
import {Constants} from "../../util/Constants";


@Injectable()
export class UserService {
  // Observable string sources
  public emitChangeSource = new Subject();

  // Observable string streams
  changeEmitted$ = this.emitChangeSource.asObservable();

  // Service message commands
  emitChange(change: string) {
    this.emitChangeSource.next(change);
  }

  constructor(public http: Http) {
  }

  /**
   * get agents
   * @param formData
   * @param token
   */

  getAdmins() {
    return this.http.get(Constants.ADMIN_URL + '?all=1', Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getAgents(pageSize ?: number) {
    return this.http.get(Constants.AGENT_URL+ (pageSize ? '?pageSize=' + pageSize : ''), Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // 0 - for pending, 1 - for approved, 2 - all
  getFrozenAccounts(type = 2) {
    return this.http.get(Constants.FREEZE_ACCOUNT_URL+ (type ? '?status=' + type : ''), Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getStatistics() {
    return this.http.get(Constants.ADMIN_STATISTICS_URL, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // getDataStatistics() {
  //   return this.http.get(Constants.DATA_STATISTICS_URL, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
  //     .map(res => res.json());
  // }


  // chart statistics
  getChartStatistics() {
    return this.http.get(Constants.CHART_REPORT_STATISTICS_URL, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getWalletTransactions(size : number) {
    return this.http.get(Constants.ADMIN_WALLET_URL + '?pageSize='+ size, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getAirtimeTransactions(period?: string, download = 0, success = 1, failed = 1, pending = 1) {
    if (period && download==0) {
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + '/' + period,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && download==1) {
      return this.http.get(Constants.AIRTIME_TRANSACTIONS + '/' + period + 'download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed + '&downloadPending=' + pending,
        Constants.getFileRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      ;
    }
      return this.http.get(Constants.AIRTIME_TRANSACTIONS,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());

  }


  getDataTransactions(period?: string, download = 0, success = 1, failed = 1, pending = 1) {
    if (period && download==0) {
      return this.http.get(Constants.DATA_TRANSACTIONS + '/' + period,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && download==1) {
      return this.http.get(Constants.DATA_TRANSACTIONS + '/' + period + 'download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed + '&downloadPending=' + pending,
        Constants.getFileRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        ;
    }
    return this.http.get(Constants.DATA_TRANSACTIONS,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());

  }

  retryTransaction(tranxId : any){
    return this.http.put(Constants.TRANSACTIONS + '/retry/' + tranxId , {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  refundTransaction(tranxId : any){
    return this.http.put(Constants.TRANSACTIONS + '/refund/' + tranxId , {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  updateTransactionToSuccess(tranxId : any){
    return this.http.put(Constants.TRANSACTIONS + '/update-successful/' + tranxId , {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


 // fund-requests-range?startDate=1522540800000&endDate=1522972800000&status=2

  getFundRequestHistory(period?: string, useRange?:boolean) {
    if (period && useRange == false) {
      return this.http.get(Constants.FUND_REQUESTS + '?status=2',
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && useRange) {
      return this.http.get(Constants.FUND_REQUESTS_RANGE + period + '&status=2',
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    return this.http.get(Constants.FUND_REQUESTS_HISTORY,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  getWalletTransactionsByPeriod(period?: string, download = 0, success = 1, failed = 1, pending = 1) {
    if (period && download==0) {
      return this.http.get(Constants.WALLET_TRANSACTIONS + '/' + period,
        Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
        .map(res => res.json());
    }
    else if (period && download==1) {
      return this.http.get(Constants.WALLET_TRANSACTIONS + '/' + period + 'download=' + download
        + '&downloadSuccessful=' + success + '&downloadFailed=' + failed + '&downloadPending=' + pending,
        Constants.getFileRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)));
    }
    return this.http.get(Constants.WALLET_TRANSACTIONS,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  // get all customers
  getCustomers() {
    return this.http.get(Constants.CUSTOMER_URL, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // update customer
  updateCustomer(userData: any, userId: number) {
    return this.http.put(Constants.CUSTOMER_URL + 'update/' + userId, userData,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


// block user
  blockUser(setId: any) {
    return this.http.put(Constants.USERS_URL + setId + Constants.BLOCK, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  configureUserStatus(setId: any, status: boolean) {
    return this.http.put(Constants.AGENT_URL + 'configure/' + setId + '/api-user-status?status=' + status , {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // resend mail to user resend?adminId=22
  resendActivationMail(setId: any) {
    return this.http.get(Constants.ACTIVATION_URL + 'resend?adminId=' + setId,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

// unblock user
  unblockUser(setId: any) {
    return this.http.put(Constants.USERS_URL + setId + Constants.UNBLOCK, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  deleteUser(setId: any) {
    return this.http.delete(Constants.USERS_URL + setId + Constants.DELETE,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // update agent
  updateUser(userData: any, userId: number) {
    return this.http.put(Constants.AGENT_URL + 'update/' + userId, userData,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  fundWallet(agentId : any, amount: number){
    return this.http.post(Constants.AGENT_URL + 'fund-wallet/' + agentId + '/' + amount, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  freezeAccount(freezeObj : any){
    return this.http.post(Constants.FREEZE_ACCOUNT, freezeObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  transferCommissionToMain(agentId: number, amount: any) {
    return this.http.post(Constants.FUND_AGENT + '/from-commission?userId=' + agentId + '&amount=' + amount, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  updateNetworkConfig(id, networkObj: any) {
    return this.http.put(Constants.NETWORK_URL + id + '/update', networkObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  deleteNetworkConfig(setId: any) {
    return this.http.delete(Constants.USERS_NETWORK_URL + setId,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getFundRequestsHistory() {
    return this.http.get(Constants.FUND_REQUESTS_HISTORY,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // get all customers
  getNetworks() {
    return this.http.get(Constants.NETWORK_URL, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  // get airtime network config
  getAirtimeNetworkConfig() {
    return this.http.get(Constants.NETWORK_URL + 'airtime-config', Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // get customer limit config
  getCustomerLimitConfig() {
    return this.http.get(Constants.CUSTOMER_URL + 'limit', Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  updateCustomerLimitConfig(limitObj: any) {
    return this.http.put(Constants.CUSTOMER_URL + 'limit', limitObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  getGuestLimitConfig() {
    return this.http.get(Constants.GUEST_URL + 'limit', Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  updateGuestLimitConfig(limitObj: any) {
    return this.http.put(Constants.GUEST_URL + 'limit', limitObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }


  // get user airtime network config
  getUserAirtimeNetworkConfig(userID) {
    return this.http.get(Constants.NETWORK_URL + 'user-airtime-network-config/' + userID,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  deleteUserAirtimeNetworkConfig(setId: any) {
    return this.http.delete(Constants.NETWORK_URL + 'user-airtime-network-config/' + setId,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  updateAirtimeNetworkConfig(id, networkObj : any){
    return this.http.put(Constants.NETWORK_URL + '/airtime-config/' + id, networkObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  // block airtime network
  blockAirtimeNetwork(setId: any) {
    return this.http.put(Constants.NETWORKS_URL + setId + '/block-airtime', {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // unblock airtime network
  unblockAirtimeNetwork(setId: any) {
    return this.http.put(Constants.NETWORKS_URL + setId + '/unblock-airtime', {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // block data network
  blockDataNetwork(setId: any) {
    return this.http.put(Constants.NETWORKS_URL + setId + '/block-data', {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // unblock data network
  unblockDataNetwork(setId: any) {
    return this.http.put(Constants.NETWORKS_URL + setId + '/unblock-data', {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // get data network config
  getDataNetworkConfig() {
    return this.http.get(Constants.NETWORK_URL + 'data-config', Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // get user data network config
  getUserDataNetworkConfig(userID) {
    return this.http.get(Constants.NETWORK_URL + 'user-data-network-config/' + userID, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  deleteUserDataNetworkConfig(setId: any) {
    return this.http.delete(Constants.NETWORK_URL + 'user-data-network-config/' + setId,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  createUserDataNetworkConfig(configObj : any){
    return this.http.post(Constants.NETWORK_URL + 'user-data-network-config/', configObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  createUserAirtimeNetworkConfig(configObj : any){
    return this.http.post(Constants.NETWORK_URL + 'user-airtime-network-config/', configObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }

  updateDataNetworkConfig(id, networkObj : any){
    return this.http.put(Constants.NETWORK_URL + 'data-config/' + id, networkObj,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN))).
    map(res => res.json());
  }



  // block network
  blockNetwork(setId: any) {
    return this.http.put(Constants.NETWORKS_URL + setId + Constants.BLOCK, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

// unblock user
  unblockNetwork(setId: any) {
    return this.http.put(Constants.NETWORKS_URL + setId + Constants.UNBLOCK, {},
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // update network
  updateNetwork(networkFormData:any , id: any) {
    return this.http.put(Constants.NETWORKS_URL + id + '/update/', networkFormData,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  deleteNetwork(setId: any) {
    return this.http.delete(Constants.NETWORKS_URL + setId + Constants.DELETE,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


  getFundRequests() {
    return this.http.get(Constants.FUND_REQUESTS + '?status=0',
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  declineFundAgent(requestId: number) {
    return this.http.put(Constants.MANAGE_FUND_REQUEST_URL + '/' + requestId + '/decline', null,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  acceptFundAgent(requestId: number) {
    return this.http.put(Constants.MANAGE_FUND_REQUEST_URL + '/' + requestId + '/accept', null,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  fundAgent(paymentDetails: any) {
    return this.http.post(Constants.FUND_AGENT, paymentDetails, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  updateAdmin(userFormData: any, id) {
    return this.http.put(Constants.ADMIN_UPDATE_URL + id , userFormData,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // update agent
  updateAgent(agentData: any, agentId: number) {
    return this.http.put(Constants.AGENT_URL + 'update/' + agentId, agentData,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getUserAgents(id) {
    return this.http.get(Constants.AGENT_URL + '?superAgentId=' + id,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  getUserPermission(id) {
    return this.http.get(Constants.USER_PERMISSIONS_URL + id,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/users-service/user-service.ts